<template>
  <div class="chartNum">
    <div class="orderTitle">年租赁洗涤量(件)</div>
    <div class="box-item">
      <li
        :class="{
          'number-item': !isNaN(item),
          'mark-item': isNaN(item) && item != '楼',
          'unit': item == '楼',
          'firstIndex': index == 1
        }"
        v-for="(item,index) in orderNum"
        :key="index"
      >
        <span v-if="!isNaN(item)">
          <div ref="numberItem" :id="`numberItem${index}`">
            <span v-for="(child, Idx) in 10" :key="child">{{ Idx }}</span>
          </div>
        </span>
        <span
          class="comma"
          v-else
        >{{ item }}</span>
      </li>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CenterInfo',
  props: {
    salaryAmtCount: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      numberItem: null,
      salaryCount: this.salaryAmtCount,
      num: 14,
      orderNum: ['0', '0', ',', '0','0', '0', ',', '0', '0', '0', ',', '0', '0', '0'], // 默认总数
      timer: null
    }
  },
  watch: {
    salaryAmtCount() {
      this.initData()
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    setNumberTransform() {
      const numberArr = this.orderNum.filter(item => !isNaN(item))
      let count = 0
      // 缁撳悎CSS 瀵规暟瀛楀瓧绗﹁繘琛屾粴鍔?鏄剧ず璁㈠崟鏁伴噺
      for (let index = 0; index <= this.num; index++) {
        if(!isNaN(this.orderNum[index]) && this.orderNum[index] != ',') {
          const numberItems = document.getElementById(`numberItem${index}`)
          if(numberItems) {
            numberItems.style.transform = `translate(-50%, -${numberArr[index - count] * 10+0}%)`
            numberItems.style.webkitTransform = `translate(-50%, -${numberArr[index - count] * 10+0}%)`
          }
        } else {
          count += 1
        }
      }
    },
    
    // 澶勭悊鎬昏鍗曟暟瀛?
    toOrderNum(num) {
      num = num.toString()
      // 鎶婅鍗曟暟鍙樻垚瀛楃涓?
      if (num.length < 11) {
        num = '0' + num // 濡傛湭婊″叓浣嶆暟锛屾坊鍔?0"琛ヤ綅
        this.toOrderNum(num) // 閫掑綊娣诲姞"0"琛ヤ綅
      } else if (num.length === 11) {
        // 璁㈠崟鏁颁腑鍔犲叆閫楀彿
        num = num.slice(0, 2) + ',' + num.slice(2, 5) + ',' + num.slice(5, 8) + ',' +  num.slice(8, 11)
        this.orderNum = num.split('') // 灏嗗叾渚垮彉鎴愭暟鎹紝娓叉煋鑷虫粴鍔ㄦ暟缁?
      } else {
        // 璁㈠崟鎬婚噺鏁板瓧瓒呰繃鍏綅鏄剧ず寮傚父
        console.log('鎬婚噺鏁板瓧杩囧ぇ')
      }
      this.setNumberTransform()
    },
    
    initData() {
      setTimeout(() => {
        this.toOrderNum(Number(this.salaryAmtCount))
      }, 1200)
    }
  }
}
</script>


<style scoped lang='scss'>

.chartNum {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 0.6rem 0.4rem 1rem 0.4rem;
  flex-direction: column;
  overflow: hidden;
  .orderTitle {
    font-family: PingFangSC-Medium;
    font-weight: 400;
    line-height: 2rem;
    font-size: 2rem;
    color: #89BFFF;
    flex-shrink: 0;
    text-align: center;
    margin-bottom: 0.5rem;
  }
  /*璁㈠崟鎬婚噺婊氬姩鏁板瓧璁剧疆*/
  .box-item {
    position: relative;
    margin: 0;
    width: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 8px;
    font-size: 44px;
    // line-height: 3vw;
    text-align: center;
    list-style: none;
    color: #2d7cff;
    writing-mode: horizontal-tb;
    text-orientation: mixed;
    /*鏂囧瓧绂佹缂栬緫*/
    -webkit-user-select: none; // webkit
    user-select: none;
    //   overflow: hidden;
  }
  .unit,
  .mark-item {
    font-size: 2.2rem;
    position: relative;
    & > span {
      position: absolute;
      width: 100%;
      bottom: 0;
      writing-mode: horizontal-tb;
      text-orientation: mixed;
    }
  }
  /* 榛樿閫楀彿璁剧疆 */
  .mark-item {
    width: 16px;
    flex: 0 0 16px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    .comma {
      font-family: 'pingFangSC-Medium';
      color: rgba(95, 187, 240, 1);
      line-height: 1;
    }
  }
  .unit {
    width: 76.8px; // 4vw = 76.8px
    height: auto;
    font-size: 48px; // 2.5vw = 48px
  }
  /*婊氬姩鏁板瓧璁剧疆*/
  .number-item {
    width: 40px;
    height: 44px;
    flex: 0 0 40px;
    list-style: none;
    margin: 0 !important;
    background: 
      linear-gradient(transparent, 50%, #1D4CC0);
    & > span {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
      overflow: hidden;
      & > div {
        > span {
          font-family: pingFangSC-Medium;
          background: 
            linear-gradient(#B6E9FD 0.5%, #80CBF6 100%),
            -webkit-linear-gradient(#B6E9FD 0.5%, #80CBF6 100%);
          color: transparent;
          background-clip: text;
          -webkit-background-clip: text;
          display: block;
          line-height: 44px;
        }
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, 0);
        transition: transform 1s ease-in-out;
        -webkit-transform: translate(-50%, 0);
        -webkit-transition: transform 1s ease-in-out;
        // letter-spacing: clamp(0.1rem, 0.5vw, 1rem);
      }
    }
  }
  .box-item {
    .number-item:nth-child(4n + 2)  {
      margin-right: 0 !important;
    }
    .number-item:nth-child(4n + 4)  {
      margin-left: 0 !important;
    }
  }

  .firstIndex {
    margin-left: 0;
  }
  .number-item:last-child {
    margin-right: 0;
  }
  
  // 濯掍綋鏌ヨ - 灞忓箷瀹藉害 >= 1520px
  @media screen and (max-width: 0px) and (min-width: 1520px) {
    .orderTitle {
      font-size: 1.8rem;
      line-height: 1.8rem;
      margin-bottom: 0.4rem;
    }
    
    .box-item {
      width: 100%;
      font-size: 50px;
      justify-content: space-between;
      transform: none;
    }
    
    .mark-item {
      width: 24px;
      height: 2.7rem;
    }
    
    .unit {
      width: 64px;
      font-size: 40px;
    }
    
    .number-item {
      width: 52px;
      height: 48px;
      flex: 0 0 52px;
      margin: 0 !important;
      
      & > span > div > span {
        line-height: 48px;
      }
    }
    
    .box-item {
      .number-item:nth-child(4n + 2) {
        margin-right: 0 !important;
      }
      .number-item:nth-child(4n + 4) {
        margin-left: 0 !important;
      }
    }
    
    .firstIndex {
      margin-left: 0;
    }
    
    .number-item:last-child {
      margin-right: 0;
    }
  }
  
  // 濯掍綋鏌ヨ - 灞忓箷瀹藉害 >= 1400px 涓?< 1520px
  @media screen and (max-width: 0px) and (min-width: 1400px) and (max-width: 1519px) {
    .orderTitle {
      font-size: 1.6rem;
      line-height: 1.6rem;
      margin-bottom: 0.35rem;
    }
    
    .box-item {
      width: 100%;
      font-size: 50px;
      justify-content: space-between;
    }
    
    .mark-item {
      width: 21px;
      height: 2.4rem;
    }
    
    .unit {
      width: 56px;
      font-size: 35px;
    }
    
    .number-item {
      width: 52px;
      height: 48px;
      flex: 0 0 52px;
      margin: 0 !important;
      
      & > span > div > span {
        line-height: 48px;
      }
    }
    
    .box-item {
      .number-item:nth-child(4n + 2) {
        margin-right: 0 !important;
      }
      .number-item:nth-child(4n + 4) {
        margin-left: 0 !important;
      }
    }
    
    .firstIndex {
      margin-left: 0;
    }
    
    .number-item:last-child {
      margin-right: 0;
    }
  }

  // 1280 * 680 special fit
  @media screen and (max-width: 0px) and (max-width: 1280px) and (max-height: 700px) {
    padding: 0.2rem 0 0.25rem 0;

    .orderTitle {
      font-size: 1.5rem;
      line-height: 1.5rem;
      margin-bottom: 0.08rem;
    }

    .box-item {
      width: 100%;
      margin: 0;
      justify-content: space-between;
      font-size: 46px;
      transform: none;
    }

    .number-item {
      width: 52px;
      height: 48px;
      flex: 0 0 52px;
      margin: 0 !important;

      & > span > div > span {
        line-height: 48px;
      }
    }

    .mark-item {
      width: 20px;
      flex: 0 0 20px;
      height: 48px;
      margin: 0;
      align-items: flex-end;

      .comma {
        font-size: 2.4rem;
        line-height: 1;
        transform: translateY(6px);
      }
    }

    .unit {
      width: 38px;
      font-size: 22px;
    }

    .firstIndex {
      margin-left: 0 !important;
    }
  }
  
  // 濯掍綋鏌ヨ - 灞忓箷瀹藉害 < 1400px
  @media screen and (max-width: 0px) and (max-width: 1399px) and (min-height: 701px) {
    .orderTitle {
      font-size: 1.4rem;
      line-height: 1.4rem;
      margin-bottom: 0.3rem;
    }
    
    .box-item {
      font-size: 36px;
    }
    
    .mark-item {
      width: 18px;
      height: 2.1rem;
    }
    
    .unit {
      width: 48px;
      font-size: 30px;
    }
    
    .number-item {
      width: 44px;
      height: 36px;
      margin: 0 0.15rem;
      
      & > span > div > span {
        line-height: 36px;
      }
    }
    
    .box-item {
      .number-item:nth-child(4n + 2) {
        margin-right: 6px;
      }
      .number-item:nth-child(4n + 4) {
        margin-left: 6px;
      }
    }
    
    .firstIndex {
      margin-left: 3px;
    }
    
    .number-item:last-child {
      margin-right: 0;
    }
  }
}
</style>


